// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__eYG2c","additionalInfo":"AgreementModal_additionalInfo__1iXF7"};